import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import directive from './directive' // directive
import 'normalize.css';  // 引入 Normalize.css
import './assets/style/index.css'
import './utils/progress' // permission control
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

 
Vue.use(ElementUI);
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"


Vue.component('ImagePreview', ImagePreview)
Vue.config.productionTip = false

Vue.use(directive)
new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
